import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: '/404', pathMatch: 'full' },
    {
        path: '404',
        title: '404 | Store not found',
        loadComponent: () => import('./not-found/not-found.component').then(m => m.NotFoundComponent)
    },
    {
        path: 'account',
        loadChildren: () => import('account/account.module').then(m => m.AccountModule), // Lazy load account module
        data: { preload: true }
    },
    {
        path: 'app',
        loadChildren: () => import('app/app.module').then(m => m.AppModule), // Lazy load account module
        data: { preload: true }
    },
    {
        // Public storefront. This route deliberately does not use AppRouteGuard.
        path: 'store',
        loadChildren: () => import('storefront/storefront.module').then(m => m.StorefrontModule)
    },
    { path: '**', redirectTo: '/404' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
    providers: []
})
export class RootRoutingModule { }
